import { Card, Form, Modal, Radio } from "antd";
import { useEffect, useState } from "react";
import { ContainerModalAssinatura, Title } from "../styles";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { layout } from "../../ViewInteresses/styles";
// --------------------- Import dayJS ---------------------

import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { useTroca } from "../hooks/useTroca";
import { useNavigate } from "react-router-dom";

export default function ModalTroca({
  isModalOpen,
  handleFechar,
  cotaUsuarioId,
  aceitaTroca,
}: any) {
  const [formTroca] = Form.useForm();

  const [trocaData, setTrocaData] = useState<Partial<CotaUsuario>>({});

  const { error, success, loading, resetError, resetSuccess, cadastrar } =
    useTroca();

  // Exibe a Mensagem
  const { showError, showSuccess, contextHolder } = useMessage();

  // Função que armazena os dados alterados de Apartamento
  const trocaChange = (
    changedValues: Partial<CotaUsuario>,
    allValues: Partial<CotaUsuario>
  ) => {
    setTrocaData({
      ...allValues,
    });
  };

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        navigate(0);
      }, 2000);
    }

    if (error && !errorDisplayed) {
      // Mensagem de erro

      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
  ]);

  useEffect(() => {
    if (isModalOpen) {
      formTroca.setFieldsValue({
        aceitaTroca: aceitaTroca,
      });
      setTrocaData({ aceitaTroca });
    }
  }, [isModalOpen, aceitaTroca]);
  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() => cadastrar(cotaUsuarioId, trocaData)}
        confirmLoading={loading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <Card
            title={<Title>Empreendimento Aceita Troca?</Title>}
            style={{
              width: "100%",
              marginTop: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {contextHolder}
            <ContainerModalAssinatura>
              <Form
                {...layout}
                form={formTroca}
                onValuesChange={(changedValues, allValues) =>
                  trocaChange(changedValues, allValues)
                }
                name="troca"
              >
                <Form.Item
                  name="aceitaTroca"
                  label="Aceita Troca?"
                  className="formItems"
                >
                  <Radio.Group>
                    <Radio value={true}>Sim</Radio>
                    <Radio value={false}>Não</Radio>
                  </Radio.Group>
                </Form.Item>
              </Form>
            </ContainerModalAssinatura>
          </Card>
        }
      </Modal>
    </>
  );
}
